export default "__VITE_ASSET__fd906c5a__"